<div class="badge" [style.background-color]="getBackgroundColor()" [style.color]="getTextColor()"
  [class.clickable]="action" [matTooltip]="getTooltip()" (click)="onClick($event)">
  @if (icon) {
  <mat-icon class="badge-icon">{{ icon }}</mat-icon>
  }
  @if (translationKeyFull) {
  {{ translationKeyFull | translate }}
  } @else {
  {{ getDisplayValue() }}
  }
</div>